export default __webpack_public_path__ + "static/media/host_status.15eb5aac.svg";